module.exports = __webpack_public_path__ + "assets/63c2462305af034ab0553844d7439c41.mp3";